module.exports = __webpack_public_path__ + "static/img/info.0d269a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/info.png
// module id = twLD
// module chunks = 57